angular.module('cvsApp').service('searchUserService', ['networkService', 'xdrService', 'configManager',
    'searchUserModel', 'cvsAppData', '$base64', function (NS, XS, CM, SUM, CAD, $base64) {

        function searchUser() {
            this.searchUser = function (callBackSuccess, oSearchUser) {
                //get url
                // var tokenId = CAD.getTokenId();
                // var tokenType = CAD.getTokenType();
                var apikey = CAD.getApiKey();
                var params = "&tokenID=" + oSearchUser.tokenID + "&tokenType=SuperUser" +
                "&maxResults=" + oSearchUser.maxResults + "&email=" +  oSearchUser.email +
                "&dateOfBirth=" + oSearchUser.dateOfBirth + "&firstName=" + oSearchUser.firstName +
                "&lastName=" + oSearchUser.lastName;
                var url = CM.getApiUrlWithApikeyAndAppName('SEARCH_USER', "SPL") + params;

                if (url === "URL_ERROR") {

                } else {
                    var plainUrl = CM.getPlainApiUrl(url);
                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {
                        url: plainUrl,
                        header: {
                            'Content-Type': 'application/json',
                            'accept': 'application/xml'
                        },
                        data:getRequestBody(url),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(plainUrl, "searchUser", SUM, request, callBackSuccess, NS);
                }

            };
            
            var getRequestBody = function(entities){
                var requestJson = { serviceParams: CM.getModifiedParams(entities) };
                return requestJson;
            };

        }

        return new searchUser();
    }]);